import type { ConsoleRole } from './types';

/**
 * Single source of truth for client-side route role gates. Backend remains the
 * enforcement boundary (each use case re-checks scopes) — these gates only hide
 * the UI from users who would otherwise hit a 403. Keep aligned with
 * KeycloakRoleScopeMapper.java in safariat-partner-api.
 *
 * Routes not listed are visible to every authenticated role.
 */
export const ROUTE_ROLES = {
    '/api-keys': ['PARTNER_ADMIN'],
    '/audit': ['PARTNER_ADMIN', 'DEVELOPER'],
    '/team': ['PARTNER_ADMIN'],
    '/webhooks': ['PARTNER_ADMIN', 'DEVELOPER'],
    '/sandbox': ['PARTNER_ADMIN', 'DEVELOPER'],
    '/settings': ['PARTNER_ADMIN'],
} as const satisfies Record<string, readonly ConsoleRole[]>;

export type ProtectedRoutePath = keyof typeof ROUTE_ROLES;

export function isProtectedRoute(path: string): path is ProtectedRoutePath {
    return path in ROUTE_ROLES;
}
